var App = App || {};

App.SegmintAssistant = (function ($) {
    'use strict';

    function init() {
        $(document).ready(function () {
            $(".seg-zone-assistant").each(function (index) {
                var assistantDiv = $(this);
                var zoneId = assistantDiv.attr("data-seg-assistant-zone-id");

                //segmint funtion that returns html associated with provided zoneId
                window.$egmint.getHtmlOffer(zoneId, function (response, error) {
                    if (error) {
                        console.log("Error with zone ID: " + zoneId);
                        $("#seg-" + zoneId).remove();
                    }
                    else {
                        //add response html as element before assistant element
                        var temp = document.createElement('template');
                        temp.innerHTML = response.content;
                        assistantDiv[0].parentElement.insertBefore(temp.content, assistantDiv[0]);
                        
                        var addedIndex = assistantDiv.parent().attr("data-index");
                        var addedTitle = $(assistantDiv.prev());
                        var defaultZone = $(assistantDiv.prevAll().eq(3));

                        //Move segmint title to associated title area
                        if (addedTitle.hasClass("segmint-title-text")) {
                            var banner = assistantDiv.closest(".homepage-banner");
                            banner.find('.card-text[data-index="' + addedIndex + '"]').find(".title-text").text(addedTitle.text());
                            addedTitle.remove();
                        }
                        defaultZone.remove();
                    }
                })
            });
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SegmintAssistant.init();
});